export enum ActionsStyle {
    Flat,
    Dots
}
